<template>
  <v-container>
    <v-row>
      <p class="font-weight-bold">{{ $t("bus_declaration") }}</p>
      <p class="d-flex">
        <v-checkbox
          class="mt-0"
          v-model="addProfilePayload.is_declared"
          @input="$v.is_declared.$touch()"
          :error-messages="applicantErrors"
          hide-details
        ></v-checkbox
        ><span class="mt-1">{{ $t("bus_declaration_text") }}</span>
      </p>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-btn
          color="primary"
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickNext"
          >{{ $t("Submit") }}
        </v-btn>
      </v-col>
    </v-row>
    <loading
      :active="loader"
      :is-full-page="fullPage"
      :opacity="0.9"
      color="#ff6b00"
      :height="height"
      :width="width"
    />
  </v-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  data: () => ({
    loader: false,
    addProfilePayload: {
      is_declared: "",
    },
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
  }),
  computed: {
    applicantErrors() {
      const errors = [];
      if (!this.$v.addProfilePayload.is_declared.$dirty) return errors;
      !this.$v.addProfilePayload.is_declared.required &&
        errors.push("required");
      return errors;
    },
  },
  validations() {
    return {
      addProfilePayload: {
        is_declared: {
          required,
        },
      },
    };
  },
  mounted() {
    if (this.$route.query.customer_id) {
      this.getdeclaration();
    }
  },
  components: {
    Loading,
  },
  methods: {
    onClickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.postList();
    },

    async getdeclaration() {
      try {
        const responseData = await businessService.getDeclarationData({
          customer_id: this.$route.query.customer_id,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.addProfilePayload = {
            is_declared: responseData.data.data[0].is_declared,
          };
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
      }
    },

    async postList() {
      this.loader = true;
      try {
        const responseData = await businessService.addDeclarationData(
          this.addProfilePayload,
          {
            customer_id: this.$route.query.customer_id,
            is_declared: this.addProfilePayload.is_declared,
          }
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
          this.alertMsg.status = true;
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
  },
};
</script>
